<template>
  <v-container>
    <loading
      :active="loader"
      :is-full-page="true"
      :opacity="0.9"
      color="#ff6b00"
    />
    <v-row>
      <v-col cols="12" md="6">
        <label>{{ $t("bank_name_business") }}</label>
        <v-autocomplete
          :placeholder="$t('bank_name_placeholder')"
          v-model="addProfilePayload.bank_name"
          :items="bank_names"
          required
          outlined
          dense
          :error-messages="banknameerrors"
          @input="$v.addProfilePayload.bank_name.$touch()"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="6">
        <label>{{ $t("bank_account_no_business") }}</label>
        <v-text-field
          :placeholder="$t('bank_account_no_placeholder')"
          dense
          outlined
          required
          :error-messages="accountnumber"
          @input="$v.addProfilePayload.bank_account_number.$touch()"
          v-model="addProfilePayload.bank_account_number"
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="12">
        <v-btn
          class="float-right mt-5 px-5 btn-primary-outlined text-capitalize"
          color="primary"
          @click="onClickNext"
          >{{ $t("Save") }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Loading from "vue-loading-overlay";
import { alpha } from "@/utils/validate";
import { required, numeric } from "vuelidate/lib/validators";
import businessService from "@/services/BusinessService/businessService.js";
import setupService from "@/services/SetupService/setupService";
import alerts from "@/mixins/alerts";
export default {
  mixins: [alerts],
  data: () => ({
    loader: false,
    bank_names: [],
    addProfilePayload: {
      bank_name: "",
      bank_account_number: "",
    },
  }),
  name: "BankDetails",
  components: {
    Loading,
  },
  computed: {
    banknameerrors() {
      const errors = [];
      if (!this.$v.addProfilePayload.bank_name.$dirty) return errors;
      !this.$v.addProfilePayload.bank_name.required &&
        errors.push(this.$t("bank_name_required"));
      return errors;
    },

    accountnumber() {
      console.log("log", this.$v);
      const errors = [];
      if (!this.$v.addProfilePayload.bank_account_number.$dirty) return errors;
      !this.$v.addProfilePayload.bank_account_number.required &&
        errors.push(this.$t("bank_acc_numb_req"));
      !this.$v.addProfilePayload.bank_account_number.numeric &&
        errors.push(this.$t("only_type_numb"));
      return errors;
    },
  },

  validations() {
    return {
      addProfilePayload: {
        bank_name: {
          required,
          alpha,
        },
        bank_account_number: {
          required,
          numeric,
        },
      },
    };
  },

  created() {
    if (this.$route.query.customer_id) {
      this.getOthersdata();
    }
    this.getpayLocation("B", "MYS");
  },

  methods: {
    async getOthersdata() {
      try {
        const responseData = await businessService.getOthersData({
          customer_id: this.$route.query.customer_id,
        });
        if (responseData.data.status_code === 200) {
          this.addProfilePayload = {
            bank_name: responseData.data.data[0].bank_name,
            bank_account_number: responseData.data.data[0].bank_account_number,
          };
        }
      } catch (e) {
        console.error(e);
        return;
      }
    },
    onClickNext() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$emit("onNextClick", this.addProfilePayload);
      this.postList();
    },
    onClickBack() {
      this.$emit("onClickBack");
    },
    async getpayLocation(payment_mode, selected_country) {
      try {
        const responseData = await setupService.getAllBanks(
          selected_country,
          payment_mode
        );
        if (responseData.status == 200) {
          this.bank_names = await responseData.data.data.map((i) => i.name);
        }
      } catch (error) {
        console.log(error);
      }
    },

    async postList() {
      this.loader = true;
      try {
        const responseData = await businessService.addOtherData(
          this.addProfilePayload,
          {
            customer_id: this.$route.query.customer_id,
          }
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.loader = false;
        } else {
          this.loader = false;
          this.showAlertError(responseData.data.message);
          this.alertMsg.status = true;
        }
      } catch (error) {
        this.loader = false;
        this.showAlertError(
          "Error: Something went wrong please try again later."
        );
        console.warn("Error", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";
.invalid-feedback-name {
  display: flex;
  flex-direction: column;
  text-align: initial;
  font-size: 13px;
  background-color: #f5f5f5;
  color: #dc3545;
}
</style>
